export default __webpack_public_path__ + "static/media/Interior (1).a95742a9.jpg";